<template>
  <div>
    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="전체 주문 신청 내역"
      desc=""
    ></admin-filter>

    <div class="flex" style="position: relative">
      <div class="basic-tab" :class="{'tab-selected': selectedTab===0}" @click="selectedTab=0">주문번호별</div>
      <div class="basic-tab" :class="{'tab-selected': selectedTab===1}" @click="selectedTab=1">상품주문번호별</div>
      <button class="button" style="position:absolute;top:0;right:0;width:auto" @click="clickInvoice">송장번호 일괄등록하기</button>
    </div>

    <!-- 탭 1 -->
    <order-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 nextPageName="nopage"
                 :table_width="800"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength" v-if="selectedTab===0">
      <td slot="checkspot" slot-scope="props">
        <lp-check-bool
          v-if="checkArr[props.idx]!==undefined"
          :checkedVal.sync="checkArr[props.idx].value"></lp-check-bool>
      </td>

      <!-- index -->
      <td slot="index" slot-scope="props">{{ props.item.index }}</td>

      <!-- 주문번호 -->
      <td slot="id" slot-scope="props">
        <div @click="clickDetail(props.item.id)" style="cursor:pointer;font-weight:bold">{{ props.item.id }}</div>
      </td>

      <!-- 날짜 -->
      <td slot="created_time" slot-scope="props">{{ props.item.created_time }}</td>

      <!-- 주문자 -->
      <td slot="order" slot-scope="props">{{ props.item.order }}</td>

      <!-- 주문 상품 -->
      <td slot="product" slot-scope="props">
        <div style="text-align: left">
          <div v-for="(pp,idx) in props.item.product" :key="'pp-'+idx" v-if="enableShow(pp.status)">
            <div>상품이름: {{ pp.name }}</div>
            <div class="flex" style="flex-wrap:wrap;">
              <div v-if="pp.option">
                <div>
                  옵션명: <span>{{ pp.option.name }}</span>
                </div>
                <div>
                  옵션가격: <span>{{ pp.option.price }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </td>

      <!-- 총 상품 금액-->
      <td slot="product_price" slot-scope="props">{{ props.item.product_price | currency }}</td>

      <!-- 배송 금액 -->
      <td slot="delivery_price" slot-scope="props">{{ props.item.delivery_price | currency }}</td>

      <!-- 할인 금액 -->
      <td slot="discount_price" slot-scope="props">{{ props.item.discount_price | currency }}</td>

      <!-- 전체 금액-->
      <td slot="total_price" slot-scope="props">{{ props.item.total_price | currency }}</td>

      <!-- 결제 방법 -->
      <td slot="pay_type" slot-scope="props">{{ props.item.pay_type }}</td>

      <!-- 일괄 처리 -->
      <div slot="spot">
        <div class="flex align-center" style="background-color: #eee; padding: 8px">
          <span>선택한 주문을</span>
          <span class="select" style="margin-left: 8px">
            <select v-model="status" @change="e=> status=e.target.value">
              <option value="" disabled selected>주문상태</option>
              <option :value="item.value" v-for="(item,idx) in status_arr" :key="'status-'+idx">{{ item.label }}</option>
            </select>
          </span>
          <button class="button" style="margin-left:8px" @click="clickChange">일괄처리</button>
          <button class="button" style="margin-left:8px" @click="cancelPurchase">취소처리</button>
        </div>
      </div>
    </order-table>

    <!-- 탭 2 -->
    <order-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 nextPageName="nopage"
                 :table_width="800"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength" v-if="selectedTab===1">
      <td slot="checkspot" slot-scope="props">
        <lp-check-bool
          v-if="checkArr[props.idx]!==undefined"
          :checkedVal.sync="checkArr[props.idx].value"></lp-check-bool>
      </td>

      <!-- 번호 -->
      <td slot="index" slot-scope="props">{{ props.item.index }}</td>

      <!-- 상품 주문번호 -->
      <td slot="id" slot-scope="props">
        <div @click="clickDetail(props.item.purchase)" style="cursor:pointer;font-weight:bold">{{ props.item.id }}</div>
      </td>

      <!-- 날짜 -->
      <td slot="created_time" slot-scope="props">{{ props.item.created_time }}</td>

      <!-- 주문자 -->
      <td slot="order" slot-scope="props" :rowspan="props.item.rowspan" v-if="!props.item.is_duplicate">{{ props.item.order }}</td>

      <!-- 주문 상품 -->
      <td slot="product" slot-scope="props">
        <div v-if="enableShow(props.item.product.status)" style="text-align: left">
          <div>상품이름: {{ props.item.product.name }}</div>
          <div class="flex" style="flex-wrap:wrap;">
            <div v-if="props.item.product.option">
              <div>
                옵션명: <span>{{ props.item.product.option.name }}</span>
              </div>
              <div>
                옵션가격: <span>{{ props.item.product.option.price | currency }}</span>
              </div>
            </div>
          </div>
        </div>
      </td>

      <!-- 수량 -->
      <td slot="quantity" slot-scope="props">{{ props.item.quantity }}</td>

      <!-- 총 상품 금액-->
      <td slot="product_price" slot-scope="props">{{ props.item.product_price | currency }}</td>

      <!-- 배송 금액 -->
      <td slot="delivery_price" slot-scope="props">{{ props.item.delivery_price | currency }}</td>

      <!-- 할인 금액 -->
      <td slot="discount_price" slot-scope="props">{{ props.item.discount_price | currency }}</td>

      <!-- 전체 금액-->
      <td slot="total_price" slot-scope="props" :rowspan="props.item.rowspan" v-if="!props.item.is_duplicate">{{ props.item.total_price | currency }}</td>

      <!-- 파트너명 -->
      <td slot="partner" slot-scope="props">{{ props.item.partner }}</td>

      <!-- 주문 상태 -->
      <td slot="status" slot-scope="props">{{ orderStatus(props.item.status) }}</td>

      <!-- 결제 상태 -->
      <td slot="pay_status" slot-scope="props">{{ payStatus(props.item.status )}}</td>

      <!-- 결제 방법 -->
      <td slot="pay_type" slot-scope="props">{{ props.item.pay_type }}</td>

      <!-- 일괄 처리 -->
      <div slot="spot">
        <div class="flex align-center" style="background-color: #eee; padding: 8px">
          <span>선택한 주문을</span>
          <span class="select" style="margin-left: 8px">
            <select v-model="status" @change="e=> status=e.target.value">
              <option value="" disabled selected>주문상태</option>
              <option :value="item.value" v-for="(item,idx) in status_arr" :key="'status-'+idx">{{ item.label }}</option>
            </select>
          </span>
          <button class="button" style="margin-left:8px" @click="clickChange">일괄처리</button>
          <button class="button" style="margin-left:8px" @click="cancelPurchase">취소처리</button>
        </div>
      </div>
    </order-table>

    <modal name="cancelModal" :adaptive="true" height="auto" class="modal-style">
      <admin-box-item title="삭제" :useTab="false" class="lp-modal-wrapper">
        <div>결제취소 처리하시겠습니까?</div>
        <div class="btn-group-justify-end">
          <button class="button is-light" @click="$modal.hide('cancelModal')">취소</button>
          <button class="button is-primary" @click="confirmModal(900)">확인</button>
        </div>
      </admin-box-item>
    </modal>

    <modal name="invoiceModal" :adaptive="true" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        <div v-if="invoice_tab===1">
          <div>
            <input type="file" id="file"
                   ref="files"
                   @change="handleFileUpload"
                   :accept="acceptExt">
          </div>
          <div class="flex justify-center">
            <button class="button is-primary" @click="upload">업로드하기</button>
          </div>
        </div>
        <div v-else-if="invoice_tab===2">
          <span>성공한 횟수: {{ success_count }}</span>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
  import LpCheckBool from "../../../../module/common/LpCheckBool";
  import Const from "../../../../../utils/const"
  import ListMixin from "@/mixins/ListMixin"

  export default {
    name: 'PurchaseAll',
    components: {LpCheckBool},
    mixins: [
      ListMixin
    ],
    data() {
      return {
        acceptExt: '.xlsx',
        file: '',
        success_count: '',
        invoice_tab:1
      }
    },
    watch: {
      selectedTab(n){
        if(this.selectedTab===0){
          this.initializing('purchase', 'commerce/purchase?start_status=100&end_status=200', 'PurchaseAll');
        }
        if(this.selectedTab===1){
          this.initializing('purchase_product', 'commerce/purchaseproduct?start_status=100&end_status=200', 'PurchaseAll');
        }
      }
    },
    created() {
      this.init();
    },
    methods: {
      init() {
        this.initializing('purchase_product', 'commerce/purchaseproduct?start_status=100&end_status=200', 'PurchaseAll');
      },
      getDataFromServer() {
        this.getData();
      },
      clickInvoice(){
        this.$modal.show('invoiceModal');
        this.invoice_tab = 1;
      },
      // 상품 보여줄지
      enableShow(status) {
        if(status>=100 && status<=200) return true;
        else return false;
      },
      // 송장 업로드
      handleFileUpload() {
        this.file = this.$refs.files.files[0];

        if (this.file.size > 115343360) {
          this.toast('최대 10MB 파일까지만 업로드 가능합니다.');
          return;
        }
      },
      upload() {
        if(!this.file) return;
        let formData = new FormData();

        formData.append('file', this.file);
        console.log(formData)

        this.$axios.post(this.getUrl('commerce/product/invoice'), formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
          .then(res => {
            if (res.status === 200) {
              this.toast('업로드 되었습니다.');
              this.success_count = res.data.success_count;
              this.invoice_tab = 2;
              this.$refs.files.value = "";
            }
          })
          .catch(error => {
            //console.log(error);
            this.toast('등록된 형식의 문서가 아닙니다.');
            this.$refs.files.value = "";
          });
      },
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'
</style>
